import { extractImageFrames, clampTo } from '../../tools';
import type { baiduModelConfig } from '../types';


export const hailuoConfigs: Record<string, baiduModelConfig> = {
    'hailuo-2.3': {
        // https://cloud.baidu.com/doc/VOD/s/mm3h9frta#texttovideoh23taskinput
        // https://cloud.baidu.com/doc/VOD/s/mm3h9frta#imagetovideoh23taskinput
        apiPath: (params) => {
            const { frameMode } = params;
            if (frameMode === 'first') {
                return '/v3/aigc/image_to_video';
            } else {
                return '/v3/aigc/text_to_video';
            }
        },
        pollApiPath: '/v3/tasks/{id}',
        enableTranslation: false,
        statusMapping: {
            taskIdPath: 'taskId',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['RUNNING'],
            statePath: 'status',
            videoUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
            errorPath: 'videoGenerateTaskInfo.errMsg',
        },
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'H23',
                    modelH23TaskInput: {
                        prompt: prompt.slice(0, 2000),
                        promptOptimizer: typeof providerOptions?.promptOptimizer === 'boolean' ? providerOptions.promptOptimizer : true,
                        fastPretreatment: typeof providerOptions?.fastPretreatment === 'boolean' ? providerOptions.fastPretreatment : false,
                        duration: clampTo(duration || 6, [6, 10] as const, 6),
                        resolution: clampTo(quality || '768p', ['768p', '1080p'] as const, '768p'),
                        // 首帧 URL
                        image: firstImage,
                        // system
                        aigcWatermark: typeof providerOptions?.aigcWatermark === 'boolean' ? providerOptions.aigcWatermark : false,
                    }
                };
            } else {
                return {
                    model: 'H23',
                    modelH23TaskInput: {
                        prompt: prompt.slice(0, 2000),
                        promptOptimizer: typeof providerOptions?.promptOptimizer === 'boolean' ? providerOptions.promptOptimizer : true,
                        fastPretreatment: typeof providerOptions?.fastPretreatment === 'boolean' ? providerOptions.fastPretreatment : false,
                        duration: clampTo(duration || 6, [6, 10] as const, 6),
                        resolution: clampTo(quality || '768p', ['768p', '1080p'] as const, '768p'),
                        // system
                        aigcWatermark: typeof providerOptions?.aigcWatermark === 'boolean' ? providerOptions.aigcWatermark : false,
                    }
                };
            }
        },
    },
    'hailuo-2.3-fast': {
        // https://cloud.baidu.com/doc/VOD/s/mm3h9frta#imagetovideoh23ftaskinput
        apiPath: (params) => {
            const { frameMode } = params;
            if (frameMode === 'first') {
                return '/v3/aigc/image_to_video';
            } else {
                throw new Error('Invalid frame mode');
            }
        },
        pollApiPath: '/v3/tasks/{id}',
        enableTranslation: false,
        statusMapping: {
            taskIdPath: 'taskId',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['RUNNING'],
            statePath: 'status',
            videoUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
            errorPath: 'videoGenerateTaskInfo.errMsg',
        },
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            if (frameMode === 'first') {
                return {
                    model: 'H23F',
                    modelH23FTaskInput: {
                        prompt: prompt.slice(0, 2000),
                        promptOptimizer: typeof providerOptions?.promptOptimizer === 'boolean' ? providerOptions.promptOptimizer : true,
                        fastPretreatment: typeof providerOptions?.fastPretreatment === 'boolean' ? providerOptions.fastPretreatment : false,
                        duration: clampTo(duration || 6, [6, 10] as const, 6),
                        resolution: clampTo(quality || '768p', ['768p', '1080p'] as const, '768p'),
                        // 首帧 URL
                        image: firstImage,
                        // system
                        aigcWatermark: typeof providerOptions?.aigcWatermark === 'boolean' ? providerOptions.aigcWatermark : false,
                    }
                };
            } else {
                throw new Error('Invalid frame mode');
            }
        },
    },
    'hailuo-02': {
        // https://cloud.baidu.com/doc/VOD/s/mm3h9frta#texttovideoh20taskinput
        // https://cloud.baidu.com/doc/VOD/s/mm3h9frta#imagetovideoh20taskinput
        apiPath: (params) => {
            const { frameMode } = params;
            if (frameMode === 'first' || frameMode === 'first_last') {
                return '/v3/aigc/image_to_video';
            } else {
                return '/v3/aigc/text_to_video';
            }
        },
        pollApiPath: '/v3/tasks/{id}',
        enableTranslation: false,
        statusMapping: {
            taskIdPath: 'taskId',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['RUNNING'],
            statePath: 'status',
            videoUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
            errorPath: 'videoGenerateTaskInfo.errMsg',
        },
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, quality, modelUi, providerOptions } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            if (frameMode === 'first') {
                return {
                    model: 'H20',
                    modelH20TaskInput: {
                        prompt: prompt.slice(0, 2000),
                        promptOptimizer: typeof providerOptions?.promptOptimizer === 'boolean' ? providerOptions.promptOptimizer : true,
                        fastPretreatment: typeof providerOptions?.fastPretreatment === 'boolean' ? providerOptions.fastPretreatment : false,
                        duration: clampTo(duration || 6, [6, 10] as const, 6),
                        resolution: clampTo(quality || '768p', ['512p', '768p', '1080p'] as const, '768p'),
                        // 首帧 URL
                        image: firstImage,
                        // system
                        aigcWatermark: typeof providerOptions?.aigcWatermark === 'boolean' ? providerOptions.aigcWatermark : false,
                    }
                };
            } else if (frameMode === 'first_last') {
                return {
                    model: 'H20',
                    modelH20TaskInput: {
                        prompt: prompt.slice(0, 2000),
                        promptOptimizer: typeof providerOptions?.promptOptimizer === 'boolean' ? providerOptions.promptOptimizer : true,
                        duration: clampTo(duration || 6, [6, 10] as const, 6),
                        resolution: clampTo(quality || '768p', ['512p', '768p', '1080p'] as const, '768p'),
                        // 首尾帧 URL
                        headtailImages: {
                            headImage: firstImage,
                            tailImage: lastImage,
                        },
                        // system
                        aigcWatermark: typeof providerOptions?.aigcWatermark === 'boolean' ? providerOptions.aigcWatermark : false,
                    }
                };
            } else {
                return {
                    model: 'H20',
                    modelH20TaskInput: {
                        prompt: prompt.slice(0, 2000),
                        promptOptimizer: typeof providerOptions?.promptOptimizer === 'boolean' ? providerOptions.promptOptimizer : true,
                        fastPretreatment: typeof providerOptions?.fastPretreatment === 'boolean' ? providerOptions.fastPretreatment : false,
                        duration: clampTo(duration || 6, [6, 10] as const, 6),
                        resolution: clampTo(quality || '768p', ['512p', '768p', '1080p'] as const, '768p'),
                        // system
                        aigcWatermark: typeof providerOptions?.aigcWatermark === 'boolean' ? providerOptions.aigcWatermark : false,
                    }
                };
            }
        },
    },
};